import 'utils/responsiveScreenAdapter.js';
import 'utils/beacon.js';
import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router/index';

import MtaH5 from 'mta-h5-analysis';

MtaH5.init({
  sid: '500675556', //必填，统计用的appid
  cid: '500675888', //如果开启自定义事件，此项目为必填，否则不填
  autoReport: 1, //是否开启自动上报(1:init完成则上报一次,0:使用pgv方法才上报)
  senseHash: 1, //hash锚点是否进入url统计
  senseQuery: 1, //url参数是否进入url统计
  performanceMonitor: 0 //是否开启性能监控
});

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
